"use client";

import { useEffect, useRef, useState } from "react";
import { useInfiniteHits } from "react-instantsearch";
import { sessionStorageCache } from "~/features/algolia/cache";
import { Pagination } from "~/features/products/ProductListingPage/components/Pagination";
import styles from "~/features/products/ProductListingPage/ProductListingPage.module.css";
import { useIntersectionObserver } from "~/lib/hooks/useIntersectionObserver";

export const AlgoliaLoadMore = () => {
	const [clickedOnce, setClickedOnce] = useState<boolean>(false);
	const ref = useRef<HTMLDivElement>(null!);
	const { items, isLastPage, showMore } = useInfiniteHits({
		cache: sessionStorageCache,
	});

	const observer = useIntersectionObserver(ref, {
		threshold: 0.5,
		freezeOnceVisible: false,
	});

	useEffect(() => {
		if (observer?.isIntersecting && !isLastPage) {
			showMore();
		}
	}, [observer, showMore, isLastPage]);

	if (isLastPage) return null;

	if (!clickedOnce) {
		return (
			<section data-layout="page">
				<Pagination
					type="next"
					data={{
						title: "Vis flere produkter",
						text: `Du har sett på ${items.length} produkter`,
						buttonLabel: "Last inn flere",
						onClick: () => {
							showMore();
							setClickedOnce(true);
						},
					}}
				/>
			</section>
		);
	}

	return (
		<div className={styles.infinite_loading__wrapper}>
			<div className={styles.infinite_loading__trigger} ref={ref} />
		</div>
	);
};
